import React, { Dispatch, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import ErrorBoundary from 'js/components/ErrorBoundary'
import ErrorStyles from 'js/components/ErrorStyles'
import getWidgets from 'js/page/Widget/helpers/getWidgets'

import { SetSaveButtonDisabledAction } from '../PageEditor/components/WidgetSettings/widgetOptionsReducer'

/** @deprecated should be replaced with an actual type */
type Site = any

/** @deprecated should be replaced with an actual type */
type Entity = any

/** @deprecated should be replaced with an actual type */
type Group = any

type WidgetProps = {
    guid: string
    containerGuid?: string
    site?: Site
    entity?: Entity
    group?: Group
    canEditContainer?: boolean
    rowBackgroundColor?: string
    columnWidth?: number
    isEditing?: boolean
    editMode?: boolean
    onSave: () => void
    dispatchWidgetOptions: Dispatch<SetSaveButtonDisabledAction>
}

const Widget = React.memo(
    forwardRef<HTMLDivElement, WidgetProps>(
        (
            {
                guid,
                containerGuid,
                site,
                entity,
                group,
                canEditContainer,
                rowBackgroundColor,
                columnWidth,
                isEditing,
                editMode,
                onSave,
                dispatchWidgetOptions,
            },
            ref,
        ) => {
            const { t } = useTranslation()

            const widgets = getWidgets(!!group)

            const type = entity?.type

            const Component = widgets.find(
                (widget) => widget.value === type,
            )?.component

            if (!Component) {
                console.warn(
                    `${t('page.widget-not-found')} ${t(
                        'global.type',
                    )}: ${type}`,
                )

                if (editMode) {
                    return t('page.widget-not-found')
                }

                return null
            }

            const props = {
                ref,
                guid,
                containerGuid,
                site,
                entity,
                group,
                canEditContainer,
                rowBackgroundColor,
                columnWidth,
                editMode,
                isEditing,
                onSave,
                dispatchWidgetOptions,
            }

            return (
                <ErrorBoundary
                    fallback={
                        <ErrorStyles>
                            {t('error.widget-load-error')}
                        </ErrorStyles>
                    }
                >
                    <Component {...props} />
                </ErrorBoundary>
            )
        },
    ),
)

Widget.displayName = 'Widget'

export default Widget
